import { BudgetActionTypes } from '@bridebook/web/lib/budget/action-types';
import { ChecklistActionTypes } from '@bridebook/web/lib/checklist/action-types';
import { EnquiriesActionTypes } from '@bridebook/web/lib/enquiries/action-types';
import { ShortlistActionTypes } from '@bridebook/web/lib/shortlist/action-types';
import { TPopupVersion } from '@bridebook/web/lib/ui/types';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export const getOptInPopupVersion = (actionType: string, url = ''): TPopupVersion => {
  if (actionType === 'ROUTE_CHANGE_COMPLETE' && !url) {
    // eslint-disable-next-line no-console
    console.warn(
      "getOptInPopupVersion handling a ROUTE_CHANGE_COMPLETE action without provided url. This will always return 'home'.",
    );
  }

  /** Determine popup variant based on entry action type */
  const popupVersions = {
    [ChecklistActionTypes.UPDATE_SUBTASKS_SUCCESS]: 'tasks',
    [ChecklistActionTypes.UPDATE_TASK_SUCCESS]: 'tasks',
    [BudgetActionTypes.TOGGLE_BUDGET_DRAWER]: 'budget',
    [EnquiriesActionTypes.SEND_ENQUIRY_SUCCESS]: 'enquiry',
    [ShortlistActionTypes.SAVE_TO_SHORTLIST]: 'shortlist',
  } as const;

  const actionTypeWithRouteChange = actionType as
    | keyof typeof popupVersions
    | 'ROUTE_CHANGE_COMPLETE';

  /** For route change popups, determine subtype based on route; if there's no variant somehow, fallback to 'generic' */
  return actionTypeWithRouteChange === 'ROUTE_CHANGE_COMPLETE'
    ? url.includes(UrlHelper.inbox.suppliers.main)
      ? 'inbox'
      : url.includes(UrlHelper.advice)
        ? 'articles'
        : 'home'
    : (popupVersions[actionTypeWithRouteChange] ?? 'generic');
};
